if (!customElements.get('aur-artigos-barra')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.filtersComponent = document.querySelector('aur-faceta2-peneiras');
      this.filtersColumn = document.querySelector('.aur-central-artigos-malha__peneiras');
      this.sortBy = this.querySelector('.aur-artigos-barra__ordem2');
      this.layoutSwitcher = this.querySelector('.aur-artigos-barra__arranjo');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.aur-bo-toba-peneiras');
        this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
      }

      if (this.layoutSwitcher) {
        this.productsGrid = document.querySelector('.aur-central-artigos-malha');

        this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));
        this.handleBreakpointChangeListener = this.handleBreakpointChange.bind(this);
        window.addEventListener('on:breakpoint-change', this.handleBreakpointChangeListener);

        this.applySelectedLayout();
      }
    }

    disconnectedCallback() {
      if (this.layoutSwitcher) {
        window.removeEventListener('on:breakpoint-change', this.handleBreakpointChangeListener);
      }
    }

    /**
     * Toggles open/closed state of the filters on desktop.
     */
    toggleFilters() {
      this.filterToggle.classList.toggle('aur-bi-ativo2');
      this.filtersOpen = this.filterToggle.classList.contains('aur-bi-ativo2');
      this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

      this.filtersComponent.open();
    }

    /**
     * Handles 'change' events on the layout switcher buttons.
     * @param {object} evt - Event object.
     */
    handleLayoutChange(evt) {
      const layoutColumns = this.currentColumns;

      if (theme.mediaMatches.lg) {
        this.productsGrid.dataset.aurFuliFa = evt.target.value;
        layoutColumns.lg = evt.target.value;
      } else if (theme.mediaMatches.md) {
        this.productsGrid.dataset.aurFuliPo = evt.target.value;
        layoutColumns.md = evt.target.value;
      } else if (theme.mediaMatches.sm) {
        this.productsGrid.dataset.aurFuliNo = evt.target.value;
        layoutColumns.sm = evt.target.value;
      } else if (!theme.mediaMatches.sm) {
        this.productsGrid.dataset.aurFuliPortatil = evt.target.value;
        layoutColumns.mobile = evt.target.value;
      }

      try {
        const persistedColumns = JSON.stringify(layoutColumns);
        sessionStorage.setItem('cc-products-layout', persistedColumns);
      } catch (e) {
        //
      }
    }

    /**
     * Handles when a sort by dropdown is changed (and filtering is disabled)
     * @param {object} evt - Event object.
     */
    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'aur-artigos-barra';
      window.location.href = urlObj.toString();
    }

    /**
     * Applies the users layout switcher selection.
     */
    applySelectedLayout() {
      const persistedColumns = sessionStorage.getItem('cc-products-layout');
      if (!persistedColumns) return;

      try {
        const layoutColumns = JSON.parse(persistedColumns);

        this.productsGrid.dataset.aurFuliFa = layoutColumns.lg;
        this.productsGrid.dataset.aurFuliPo = layoutColumns.md;
        this.productsGrid.dataset.aurFuliNo = layoutColumns.sm;
        this.productsGrid.dataset.aurFuliPortatil = layoutColumns.mobile;

        this.updateSelectedLayoutOption();
      } catch (e) {
        //
      }
    }

    /**
     * Handles 'change' events when the breakpoint of the viewport changes.
     */
    handleBreakpointChange() {
      this.updateSelectedLayoutOption();
    }

    /**
     * Sets the selected layout switcher input.
     */
    updateSelectedLayoutOption() {
      const layoutColumns = this.currentColumns;
      let selectedValue;

      if (theme.mediaMatches.lg) {
        selectedValue = layoutColumns.lg;
      } else if (theme.mediaMatches.md) {
        selectedValue = layoutColumns.md;
      } else if (theme.mediaMatches.sm) {
        selectedValue = layoutColumns.sm;
      } else if (!theme.mediaMatches.sm) {
        selectedValue = layoutColumns.mobile;
      }

      const options = Array.from(this.layoutSwitcher.querySelectorAll('input[name="products-layout"]'));
      options.forEach((option) => {
        option.checked = (option.value === selectedValue);
      });
    }

    /**
     * Get the current column data attributes from the DOM.
     * @returns {object} Object containing the current columns for each breakpoint.
     */
    get currentColumns() {
      return {
        mobile: this.productsGrid.dataset.aurFuliPortatil,
        sm: this.productsGrid.dataset.aurFuliNo,
        md: this.productsGrid.dataset.aurFuliPo,
        lg: this.productsGrid.dataset.aurFuliFa
      };
    }
  }

  customElements.define('aur-artigos-barra', ProductsToolbar);
}
